<template>
    <div>
      <h2>Dashboard</h2>
      <p>Overview of all apartment data</p>
      <!-- Display summary data here -->
    </div>
  </template>

  <script>
  import { mapState } from 'vuex';

  export default {
    name: 'Dashboard',
    computed: {
      ...mapState(['apartments', 'tenantRooms', 'tenantServices', 'apartmentInvoices']),
    },
  };
  </script>
